
import axiosInstance from "./axiosInstance";
export type LeaseDetails = {
  contractorName?: string;     // or orgName depending on backend
  leaseStartDate?: string;
  leaseEndDate?: string;
};
export type Asset = {
  assetId: string;
  name: string;
  type: string;
  location: string;
  locationId: string;
  departmentId: string;
  departmentName: string;
  vendorId: string;
  vendorName: string;
  orgId: string;
  orgName: string;
  status: string;
  installedDate: string;
  leased?: LeaseDetails | null;
  calibrationHistory?: CalibrationHistory[];
};

export type Calibration = {
  calibrationId: string;
  orgId: string;
  locationId: string;
  assetId: string;
  vendorId: string;
  organizationName: string;
  locationName: string;
  vendorName: string;
  assetName: string;
  contactName: string;
  contactEmail: string;
  contactNumber: string;
  taskIncharge: string;
  departmentId: string;
  departmentName: string;
  calibrationDate: string;
  calibrationDueDate: string;
  priority: string;
  daysToExpire: number;
  status: string;
  createdAt: string;
  modifiedAt: string;
  notes: string;
};

export type CalibrationHistory = {
  id: string;
  assetId: string;
  calibrationDate: string;
  status: string;
  contactName?: string;
  notes?: string;
  createdAt: string;
  calibratedDate?: string;
  certificateId?: string;
  calibrationDueDate?: string;

};

export type VendorInfo = {
  vendorId: string;
  name: string;
  contactEmail: string;
  contactNumber: string;
  status: string;
  onTimePercentage: number;
  latePercentage: number;
  missedPercentage: number;
  lastAssignedDate: string;
};



export type HeaderContext = {
  orgInfo?: {
    id: string;
    name: string;
    contact: string;
    gsTin: string;
  } | null;
  locationInfo?: {
    id: string;
    name: string;
    city: string;
    state: string;
    zipcode: string;
  } | null;
  assetInfo?: {
    id: string | null;
    name: string;
    type: string;
    status: string;
    assetEquipmentId: string;
  } | null;
  vendorInfo?: {
    id: string;
    name: string;
    contactNumber: string;
    gsTin: string;
  } | null;
  departmentInfo?: {
    id: string;
    name: string;
  } | null;
};

// get asset details
export const getAssetById = async (id: string): Promise<Asset> => {
  const res = await axiosInstance.get(`/api/assets/${id}`);
  return res.data;
};

// get calibration records
export const getCalibrationsByAssetId = async (assetId: string): Promise<Calibration[]> => {
  try {
    const res = await axiosInstance.get(
      `/api/calibrations/by-asset/${assetId}`,
    );

    return res.status === 404 ? [] : res.data;
  } catch (error) {
    return [];
  }
};


export const getCalibrationHistoryByAssetId = async (assetId: string) => {
  try {
    const res = await axiosInstance.get(
      `/api/calibration-history/asset/${assetId}`,
    );

    return res.status === 404 ? [] : res.data;
  } catch (error) {
    return [];
  }
};

// get vendor details
export const getVendorByAssetId = async (assetId: string): Promise<VendorInfo> => {
  const res = await axiosInstance.get(`/api/vendors/by-asset/${assetId}`);
  return res.data;
};

//  get header context (moved here from calibration repo)
export const getHeaderContext = async (
  orgId: string,
  locId: string,
  assetId: string,
  vendorId: string,
  departmentId: string
): Promise<HeaderContext> => {
  const { data } = await axiosInstance.get<HeaderContext>(
    "/api/calibrations/headercontext",
    {
      params: {
        orgid: orgId,
        locid: locId,
        assetid: assetId,
        vendorid: vendorId,
        departmentid: departmentId,
      },
    }
  );
  return data;
};



